import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

export default function useMachineConditionStatuses() {
	const { t: $t } = useI18n()

	const MACHINE_CONDITION_STATUSES = {
		CONDITION_STATUS_WORKING: 'working',
		CONDITION_STATUS_DECOMMISSIONED: 'decommissioned',
		CONDITION_STATUS_UNDER_REPAIR: 'under_repair',
	}

	const machineConditionStatuses = computed(() => ({
		[MACHINE_CONDITION_STATUSES.CONDITION_STATUS_WORKING]: {
			value: MACHINE_CONDITION_STATUSES.CONDITION_STATUS_WORKING,
			title: $t('Working [carStatus]'),
            color: 'green'
		},
		[MACHINE_CONDITION_STATUSES.CONDITION_STATUS_DECOMMISSIONED]: {
			value: MACHINE_CONDITION_STATUSES.CONDITION_STATUS_DECOMMISSIONED,
			title: $t('Written off'),
            color: 'red'
		},
		[MACHINE_CONDITION_STATUSES.CONDITION_STATUS_UNDER_REPAIR]: {
			value: MACHINE_CONDITION_STATUSES.CONDITION_STATUS_UNDER_REPAIR,
			title: $t('Under repair'),
            color: 'gray'
		},
	}))

	return {
		machineConditionStatuses,
		machineConditionStatusesArray: computed(() => Object.values(machineConditionStatuses.value)),
	}
}